import { atom } from 'recoil'

import type {
  ModalActivateSimulateState,
  ModalCopyState,
  ModalDeleteState,
  ModalSimulateState,
} from 'Pages/UnsubscriptionCampaignsList/types'

export const modalCopyState = atom<ModalCopyState>({
  key: 'unsubscriptionCampaignsList_modalCopyState',
  default: { show: false, idWorkflow: 0, fetching: false },
})

export const modalSimulateState = atom<ModalSimulateState>({
  key: 'unsubscriptionCampaignsList_modalSimulateState',
  default: {
    show: false,
    idWorkflow: 0,
  },
})

export const modalDeleteState = atom<ModalDeleteState>({
  key: 'unsubscriptionCampaignsList_modalDeleteState',
  default: { show: false, idWorkflow: 0, name: '' },
})

export const modalActivateSimulateState = atom<ModalActivateSimulateState>({
  key: 'unsubscriptionCampaignsList_modalActivateSimulateState',
  default: {
    idWorkflow: 0,
    mode: 'activate',
    show: false,
    recipientLimit: 0,
  },
})
